"use client";

import { useCallback } from "react";
import { useTrackEvent } from "~/hooks/useTrackEvent";
import Carousel from "~/componentsDS/Carousel";
import { CarouselApi, CarouselContentVisible, CarouselItem } from "~/components/ui/carousel";
import { data } from "./data";
import Container from "~/componentsDS/Layout/Container";
import Reveal from "~/componentsDS/Reveal";
import Heading from "~/componentsDS/Typography/Heading";
import { QuizCTA } from "~/components/features/quiz";
import { QUIZ_ROUTES } from "~/constants/quizRoutes";
import GettingStartedCarouselStepCard from "~/componentsDS/GettingStartedCarouselStepCard";
import { GTM_EVENT_NAMES } from "~/constants/gtmEvents";

const ctaTitle = "See if Oestra® Is Right for You";

const GettingStartedSection = () => {
    const sendEvent = useTrackEvent();

    const onSelect = useCallback((emblaApi: CarouselApi) => {
        if (!emblaApi) return;

        const idx = emblaApi.selectedScrollSnap();
        const item = data[idx];

        if (!item) return;

        sendEvent({
            event: "user_interaction",
            value: {
                event_name: GTM_EVENT_NAMES.ABOUT_INTERACTION,
                widget: "about_steps",
                meta_data: {
                    image_title: item.title,
                    image_count: idx + 1,
                },
            },
        });
    }, [sendEvent]);

    return (
        <section className="py-16 md:py-[96px]">
            <Container>
                <Reveal>
                    <Heading as="h2" size="sm" sizes={{ md: "md" }} className="text-primary500 md:text-center mb-6 md:mb-10">
                        Getting started is <Heading as="i" font="featureDisplay" weight="400" className="text-[28px] md:text-[36px]">simple</Heading>
                    </Heading>
                </Reveal>

                <div className="w-[100vw] md:w-full overflow-hidden mb-4 md:mb-10 max-md:-mx-6 max-md:px-6">
                    <Carousel
                        onSelect={onSelect}
                        loop={false}
                        variant="compact"
                        compactPaginationAlign="right"
                        compactPaginationBg="bg-trueBlack/10 backdrop-blur-[25px]"
                        compactPaginationDotColor="bg-gray100"
                        opts={{
                            align: "center",
                            skipSnaps: false,
                            dragFree: false
                        }}
                        className="w-full"
                    >
                        <CarouselContentVisible className="max-md:ml-[-6px] md:ml-[-26px]">
                            {data.map((step, index) => (
                                <CarouselItem
                                    key={index}
                                    className="pl-[6px] md:pl-[26px] flex-shrink-0 basis-full md:basis-1/2 xl:basis-1/3"
                                >
                                    <GettingStartedCarouselStepCard
                                        stepNumber={index + 1}
                                        {...step}
                                    />
                                </CarouselItem>
                            ))}
                        </CarouselContentVisible>
                    </Carousel>
                </div>

                <div className="flex flex-col items-center">
                    <QuizCTA
                        variant="primary"
                        eventData={{
                            widget: "about_steps",
                            event_name: GTM_EVENT_NAMES.ABOUT_INTERACTION,
                            meta_data: {
                                click_text: ctaTitle,
                            },
                        }}
                        href={QUIZ_ROUTES.HORMONE_IMBALANCE}
                        size="md"
                    >
                        {ctaTitle}
                    </QuizCTA>
                </div>
            </Container>
        </section>
    )
};

export default GettingStartedSection
